import { computed, ref, useContext, useRouter } from '@nuxtjs/composition-api'

import * as endpoints from '~/api/endpoints'
import * as orderTypeEnum from '~/enums/order-type'
import { types as itemTypes } from '~/utils/product-item-type'

import ApiErrorMessage from '~/components/api-error-message/api-error-message.vue'
import Confirmation from '~/components/create-order/order-confirmation.vue'
import OrderSummary from '~/components/create-order/order-summary.vue'


export default {
  __name: 'buy-basket-form',
  props: {
  itemId: {
    type: [Number, String],
    required: true,
  },
  itemType: {
    type: String,
    required: true,
    validator: (val) => Object.values(itemTypes).includes(val),
  },
  price: {
    type: Number,
    default: 0,
  },
},
  emits: ['bought-basket'],
  setup(__props, { emit }) {

const props = __props;

const BUY_BASKET_ERROR_MAP = {
  400: 'BuyBasketGeneralError',
  410: 'BuyBasketGoneError',
  500: 'BuyBasketGeneralError',
}





const { $axios, localePath } = useContext()
const router = useRouter()

const fetchState = ref({
  pending: false,
})
const showBuyBasketConfirmation = ref(false)
const transactionFee = ref(0)
const errorText = ref()
const error = ref()

const orderDetails = computed(() => [
  {
    price: props.price,
    quantity: 1,
    subTotal: props.price,
  },
])

function updateTransactionFee(newTransactionFee) {
  transactionFee.value = newTransactionFee
}

function setBuyBasketConfirmation(value) {
  // Reset error when trying to (re)submit
  if (value === true) {
    resetErrors()
  }

  showBuyBasketConfirmation.value = value
}

function resetErrors() {
  error.value = null
  errorText.value = null
}

const buyBasket = async () => {
  resetErrors()
  fetchState.value.pending = true

  const response = await $axios
    .post(endpoints.buyBasketById(props.itemId))
    .catch(({ response }) => {
      return response
    })
    .finally(() => (fetchState.value.pending = false))

  // Handle localized errors from the back-end
  if (response.status === 417) {
    errorText.value = Object.values(response?.data?.errors || {})?.[0]?.[0]
    error.value = response
    showBuyBasketConfirmation.value = false
  }

  // Handle localized errors from PO editor
  if (response.status in BUY_BASKET_ERROR_MAP) {
    // Set error value to make the api error message visible
    // TODO: refactor api error message component to house displaying logic on template / page level
    error.value = response
    errorText.value = BUY_BASKET_ERROR_MAP[response.status]
    showBuyBasketConfirmation.value = false
  }

  if (response.status === 202) {
    await router.push({
      path: localePath('order-confirmation'),
      query: { type: 'buy-basket' },
    })

    emit('bought-basket')
  }

  return response
}

return { __sfc: true,BUY_BASKET_ERROR_MAP, props, emit, $axios, localePath, router, fetchState, showBuyBasketConfirmation, transactionFee, errorText, error, orderDetails, updateTransactionFee, setBuyBasketConfirmation, resetErrors, buyBasket, orderTypeEnum, ApiErrorMessage, Confirmation, OrderSummary }
}

}